export const QueryKeys = {
  AllVendorsList: 'AllVendorsList',
  ThirdPartyVendorToken: 'ThirdPartyVendorToken',
};
